import NOTO_SANS from "./assets/NOTO_SANS.ttf";
import NOTO_SANS_600 from "./assets/NOTO_SANS_600.ttf";
import NOTO_SANS_JP from "./assets/NOTO_SANS_JP.ttf";
import NOTO_SANS_JP_600 from "./assets/NOTO_SANS_JP_600.ttf";
import NOTO_SANS_SC from "./assets/NOTO_SANS_SC.ttf";
import NOTO_SANS_SC_600 from "./assets/NOTO_SANS_SC_600.ttf";
import NOTO_SANS_TC from "./assets/NOTO_SANS_TC.ttf";
import NOTO_SANS_TC_600 from "./assets/NOTO_SANS_TC_600.ttf";
import NOTO_SANS_KR from "./assets/NOTO_SANS_KR.ttf";
import NOTO_SANS_KR_600 from "./assets/NOTO_SANS_KR_600.ttf";
import { FontFallback } from "@reedexpo/mercury-badge";

export type ZPLBadge = {
  height: number;
  length: number;
  rowlen: number;
  width: number;
  z64: string;
};

export const fonts: FontFallback[] = [
  {
    family: 'NOTO_SANS',
    fonts: [
      {
        src: NOTO_SANS
      },
      {
        src: NOTO_SANS_600,
        fontWeight: 600
      }
    ]
  },
  {
    family: 'NOTO_SANS_JP',
    fonts: [
      {
        src: NOTO_SANS_JP
      },
      {
        src: NOTO_SANS_JP_600,
        fontWeight: 600
      }
    ]
  },
  {
    family: 'NOTO_SANS_SC',
    fonts: [
      {
        src: NOTO_SANS_SC
      },
      {
        src: NOTO_SANS_SC_600,
        fontWeight: 600
      }
    ]
  },
  {
    family: 'NOTO_SANS_TC',
    fonts: [
      {
        src: NOTO_SANS_TC
      },
      {
        src: NOTO_SANS_TC_600,
        fontWeight: 600
      }
    ]
  },
  {
    family: 'NOTO_SANS_KR',
    fonts: [
      {
        src: NOTO_SANS_KR
      },
      {
        src: NOTO_SANS_KR_600,
        fontWeight: 600
      }
    ]
  }
] as unknown as FontFallback[];